import { LIPA_BIDHAA_BANNER_CONFIG } from "../config/lipaBidhaaBanners";
import { useLocationStateBanner } from "../../../hooks/useLocationStateBanner";

export function useLipaBidhaaBanner() {
  return useLocationStateBanner({ config: LIPA_BIDHAA_BANNER_CONFIG, stateKey: "lipaBidhaaBannerReason" });
}
